import React from 'react';
import PropTypes from 'prop-types';
import {withTranslation} from "react-i18next";
// material-ui core
import withStyles from '@material-ui/core/styles/withStyles';
// core components
import GridContainer from 'components/UI/Grid/GridContainer';
import GridItem from 'components/UI/Grid/GridItem';
import Button from 'components/UI/CustomButtons/Button';
import Card from 'components/UI/Card/Card';
import CardHeader from 'components/UI/Card/CardHeader';
import CardIcon from 'components/UI/Card/CardIcon';
import CardFooter from 'components/UI/Card/CardFooter';
// styles
import DashboardStyles from 'assets/jss/material-dashboard-pro-react/views/dashboardStyle';
// our components
import WithPermission from 'components/User/WithPermission';
import UserStats from 'components/Dashboard/UserStats';
import AdStats from 'components/Dashboard/AdStats';
import AdReviewedStats from 'components/Dashboard/AdReviewedStats';
import UserMetrics from 'components/Dashboard/UserMetrics';
import AdMetrics from 'components/Dashboard/AdMetrics';
import routes from 'routes/dashboard';
import Icon from "@material-ui/core/Icon";
import RouterContext from "helpers/routerContext";

class ScreenDashboard extends React.Component {
  static contextType = RouterContext;

  render() {
    const {
      classes,
      t,
    } = this.props;
    const history = this.context;
    return (
      <GridContainer>
        <GridItem xs={12}>
          <GridItem>
            <WithPermission alt={
              <GridContainer>
                {routes.map(prop =>
                  prop.allowPermissions ? (
                    <WithPermission
                      key={prop.name}
                      allowPermissions={prop.allowPermissions}
                    >
                      {prop.requiredPermission ? (
                        <WithPermission
                          allowPermissions={prop.requiredPermission}>
                          {prop.sidebarShow &&
                          <GridItem xs={12} sm={6} md={6} lg={6}>
                            <Card>
                              <CardHeader>
                                <CardIcon color={prop.color}>
                                  {typeof icon === 'string' ?
                                    <Icon>{prop.icon}</Icon> :
                                    <prop.icon/>
                                  }
                                </CardIcon>
                                <Button
                                  simple
                                  onClick={() => history.push(prop.path)}
                                >
                                  <h3 className={classes.cardTitle}>
                                    {t(`common.sidemenu.${prop.name}`)}
                                  </h3>
                                </Button>
                              </CardHeader>
                              <CardFooter />
                            </Card>
                          </GridItem>}
                        </WithPermission>
                      ) : (
                        prop.sidebarShow &&
                        <GridItem xs={12} sm={6} md={6} lg={3}>
                          <Card>
                            <CardHeader>
                              <CardIcon color={prop.color}>
                                {typeof icon === 'string' ?
                                  <Icon>{prop.icon}</Icon> :
                                  <prop.icon/>
                                }
                              </CardIcon>
                              <Button
                                simple
                                onClick={() => history.push(prop.path)}
                              >
                                <h3 className={classes.cardTitle}>
                                  {t(`common.sidemenu.${prop.name}`)}
                                </h3>
                              </Button>
                            </CardHeader>
                            <CardFooter />
                          </Card>
                        </GridItem>
                      )}
                    </WithPermission>
                  ) : (
                    prop.name !== 'dashboard' && prop.sidebarShow &&
                    <Button>
                      {prop.name}
                    </Button>
                  ),
                )}
              </GridContainer>
            } allowPermissions={['view_statistics']}>
              <h3>Dashboard</h3>
              <div className={classes.pageContainer}>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={4} lg={4}>
                    <UserStats/>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4} lg={4}>
                    <AdStats/>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4} lg={4}>
                    <AdReviewedStats/>
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} md={6}>
                    <UserMetrics/>
                  </GridItem>
                  <GridItem xs={12} md={6}>
                    <AdMetrics/>
                  </GridItem>
                </GridContainer>
              </div>
            </WithPermission>
          </GridItem>
        </GridItem>
      </GridContainer>
    );
  };
}

ScreenDashboard.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(withStyles(DashboardStyles)(ScreenDashboard));
